import axios from "axios";

const generateAuth = ({ email, password = null, refreshToken = null }) => {
    return axios.post(process.env.VUE_APP_GENERATE_AUTH, {
        email,
        password,
        refreshToken
    });
};

export default {
    generateAuth
};
